import "./es.regexp.exec.js";
import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/function-call.js";
import { i as e } from "../internals/is-callable.js";
import { a as s } from "../internals/an-object.js";
import { t as a } from "../internals/to-string.js";
var n,
  i,
  o = (n = !1, (i = /[ac]/).exec = function () {
    return n = !0, /./.exec.apply(this, arguments);
  }, !0 === i.test("abc") && n),
  c = /./.test;
t({
  target: "RegExp",
  proto: !0,
  forced: !o
}, {
  test: function test(t) {
    var n = s(this),
      i = a(t),
      o = n.exec;
    if (!e(o)) return r(c, n, i);
    var l = r(o, n, i);
    return null !== l && (s(l), !0);
  }
});